class PlanComparison {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
  }

  cacheDOM () {
  }

  bindEvents () {
    this.handlePlanDurationChange()
  }

  handlePlanDurationChange () {
    $( 'input[name=comparison_period]' ).on( 'change', function ( e ) {
      const currentValue = $( 'input[name=comparison_period]:checked' ).val()
      $( `input[name=period_radio][value=${ currentValue }]` ).prop( 'checked', true ).trigger( 'change' )

      $( '.table-wrapper table thead' ).find( '.rate' ).each( function ( e ) {
        if ( 'annual' === currentValue ) {
          $( this ).html( `$${ $( this ).data( 'yearly' ) }<span class="duration">/year</span>` )
          $( '.table-wrapper table thead' ).find( '.plan-table.recommended-plan' ).removeClass( 'monthly' )
        } else if ( 'monthly' === currentValue ) {
          $( this ).html( `$${ $( this ).data( 'monthly' ) }<span class="duration">/monthly</span>` )
          $( '.table-wrapper table thead' ).find( '.plan-table.recommended-plan' ).addClass( 'monthly' )
        }

      } )
    } )
  }

}

new PlanComparison()
